import React, { useEffect } from 'react';
import { CheckCircleIcon, ArrowRightIcon } from '@heroicons/react/24/outline';
import { useAuth } from '../context/AuthContext';

const SuccessPage: React.FC = () => {
  const { refreshSubscription } = useAuth();

  useEffect(() => {
    // Refresh subscription data when the success page loads
    refreshSubscription();
  }, [refreshSubscription]);

  const handleContinue = () => {
    window.location.href = '/';
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-pink-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-2xl shadow-xl p-8 text-center">
          <div className="mx-auto w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-6">
            <CheckCircleIcon className="w-8 h-8 text-green-600" />
          </div>
          
          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            Payment Successful!
          </h1>
          
          <p className="text-gray-600 mb-8">
            Thank you for your subscription. Your account has been activated and you now have access to all premium features.
          </p>

          <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-6">
            <div className="flex items-center justify-center">
              <CheckCircleIcon className="h-5 w-5 text-green-500 mr-2" />
              <span className="text-green-800 font-medium">Pro Plugin Activated</span>
            </div>
          </div>

          <button
            onClick={handleContinue}
            className="w-full bg-orange-600 text-white py-3 px-6 rounded-lg font-semibold hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 transition-colors flex items-center justify-center"
          >
            Continue to Dashboard
            <ArrowRightIcon className="h-5 w-5 ml-2" />
          </button>

          <p className="text-sm text-gray-500 mt-4">
            You can now access all premium features and manage your business efficiently.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SuccessPage;